import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-late-fees-summary',
  templateUrl: './late-fees-summary.component.html',
  styleUrls: ['./late-fees-summary.component.scss']
})
export class LateFeesSummaryComponent implements OnInit {

  @Input() items;
  @Input() title;
  @Input() language;
  @Input() locale;
  @Input() dateformat;
  currencySymbol = 'symbol';

  constructor() { }

  ngOnInit() {
    if (this.locale === 'AUD') {
      this.locale = 'AUD ';
      this.currencySymbol = 'code';
    }
  }
}
